import {createContext} from 'react'

export const OrderItemsContext = createContext({});
export const OrderDataContext = createContext({});
export const ErrorContext = createContext({});
export const LocationsContext = createContext({});
export const MenuContext = createContext({});
export const MenuGroupsContext = createContext({});
export const AvailableDatesContext = createContext({});
export const WaiterContext = createContext({});
export const TranslationsContext = createContext({});
